<template>
  <el-dropdown trigger="click" @command="handleSwitch">
    <div class="theme-switch">
      <Icon :name="currentIcon" :size="16" />
      <Icon name="ChevronDown" :size="12" />
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="item in options"
          :key="item.value"
          :command="item.value"
          :class="{ 'is-active': settingsStore.theme === item.value }"
        >
          <Icon :name="item.icon" :size="16" />
          <span>{{ t(item.label) }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSettingsStore } from '@/stores/settings'
import Icon from '@/components/Icon/index.vue'

const { t } = useI18n()
const settingsStore = useSettingsStore()

const options = [
  { label: 'theme.light', value: 'light', icon: 'Sun' },
  { label: 'theme.dark', value: 'dark', icon: 'Moon' },
  { label: 'theme.system', value: 'system', icon: 'Monitor' },
]

const currentIcon = computed(() => {
  const theme = settingsStore.theme
  if (theme === 'dark') return 'Moon'
  if (theme === 'system') return 'Monitor'
  return 'Sun'
})

function handleSwitch(value) {
  if (value === settingsStore.theme) return
  settingsStore.setTheme(value)
}
</script>

<style lang="scss" scoped>
.theme-switch {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: var(--radius-base);
  color: var(--text-secondary);
  font-size: var(--font-size-secondary);
  transition: all var(--transition-base);

  &:hover {
    color: var(--text-regular);
    background: var(--bg-page);
  }
}

:deep(.el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  gap: 8px;

  &.is-active {
    color: var(--primary);
    font-weight: 500;
  }
}
</style>
